// Scanner release data.
//
// Lifted verbatim out of the v1 DownloadPage component, where it sat inline in the
// render. Static data in a component body means editing a release note requires
// touching JSX; here it is one file that both interfaces can read.
//
// Keep newest first: the screen shows CURRENT_RELEASE prominently and collapses the
// rest behind a disclosure.

export const CURRENT_RELEASE = {
  version: "2.0.1",
  date: "10/13/2026",
  githubUrl: "https://github.com/BusinessTSG/Pipsqueak/releases/download/v2.0.1/Pipsqueak-v2.0.1-windows-x64.exe",
  s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-v2.0.1-windows-x64.exe",
  sha256: "eaf719b1857775997a31cb1d4be4129d491ebbe0d832975de44a5a4e0a2e07bf",
  virusTotalUrl: "https://www.virustotal.com/gui/file/eaf719b1857775997a31cb1d4be4129d491ebbe0d832975de44a5a4e0a2e07bf",
};

export const PREVIOUS_RELEASES = [
  {
  version: "2.0.0",
  date: "10/9/2026",
  githubUrl: "https://github.com/BusinessTSG/Pipsqueak/releases/download/v2.0.0/Pipsqueak-v2.0.0-windows-x64.exe",
  s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-v2.0.0-windows-x64.exe",
  sha256: "24c18c4dd3ece4f1c25813aa44df49e5e4c3f856d5a7ff29392a674662250c4b",
  virusTotalUrl: "https://www.virustotal.com/gui/file/24c18c4dd3ece4f1c25813aa44df49e5e4c3f856d5a7ff29392a674662250c4b",
},
  {
  version: "1.4.9",
  date: "7/31/2026",
  githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.9/Pipsqueak-windows-x64-latest.exe",
  s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-latest.exe",
  sha256: "025be58c6bacf184448bfc9c2c04f965811804d0cc930e275d81aba849620510",
  virusTotalUrl: "https://www.virustotal.com/gui/file/025be58c6bacf184448bfc9c2c04f965811804d0cc930e275d81aba849620510",
},
  
  {
    version: "1.4.8.2",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8.2/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.2.exe",
    sha256: "645ca4a1ee15a8b5953d45dee6953e91ca39ea18e41728b7be956b7a7be41d77",
    virusTotalUrl: "https://www.virustotal.com/gui/file/645ca4a1ee15a8b5953d45dee6953e91ca39ea18e41728b7be956b7a7be41d77",
  },
  {
    version: "1.4.8.1",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8.1/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.1.exe",
    sha256: "e69a96383663ed3e3ebde11adb04383bad3f4f3766346300a01cbba73e82fbe5",
    virusTotalUrl: "https://www.virustotal.com/gui/file/e69a96383663ed3e3ebde11adb04383bad3f4f3766346300a01cbba73e82fbe5",
  },
  {
    version: "1.4.8",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.8/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.8.exe",
    sha256: "8bb567a9a3f781c2d4e4224dc70092384dc4120ec385ab8091e919ad2e1acd49",
    virusTotalUrl: "https://www.virustotal.com/gui/file/8bb567a9a3f781c2d4e4224dc70092384dc4120ec385ab8091e919ad2e1acd49",
  },
  {
    version: "1.4.7",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.7/Pipsqueak-windows-x64-.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.7.exe",
    sha256: "0f0495ce78c9d29e299b8eb417174d4c8b348c64eb7eac2be8264a87855b569d",
    virusTotalUrl: "https://www.virustotal.com/gui/file/0f0495ce78c9d29e299b8eb417174d4c8b348c64eb7eac2be8264a87855b569d",
  },
  {
    version: "1.4.6",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.6/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.6.exe",
    sha256: "ea41a30d034b6e6f9d51f3e9cbe6640ddb6b602152b873e907cb9cde1c8f8df4",
    virusTotalUrl: "https://www.virustotal.com/gui/file/ea41a30d034b6e6f9d51f3e9cbe6640ddb6b602152b873e907cb9cde1c8f8df4",
  },
  {
    version: "1.4.5",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.5/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.5.exe",
    sha256: "bcebe7999a7185ffec403e2aaaa9e8d020802ef4c7ec3aa4186c816e9c41e9a3",
    virusTotalUrl: "https://www.virustotal.com/gui/file/bcebe7999a7185ffec403e2aaaa9e8d020802ef4c7ec3aa4186c816e9c41e9a3",
  },
  {
    version: "1.4.4",
    date: "",
    githubUrl: "https://github.com/BusinessTSG/Pipsqueak-Network-Scanner/releases/download/v1.4.4/Pipsqueak-windows-x64-latest.exe",
    s3Url: "https://myexefilebucket.s3.eu-north-1.amazonaws.com/Pipsqueak-windows-x64-1.4.4.exe",
    sha256: "171ec27b65258ee368b0e9ae44f81d7f4c00e6f63b9dc024c4d1596df1e3f475",
    virusTotalUrl: "https://www.virustotal.com/gui/file/171ec27b65258ee368b0e9ae44f81d7f4c00e6f63b9dc024c4d1596df1e3f475",
  }
];
